import { ReactNode } from 'react';
import { Navigate } from 'react-router-dom';
import { useAdminAuth } from '@/hooks/useAdminAuth';

interface ProtectedRouteProps {
  children: ReactNode;
}

const VALID_STAFF_ROLES = ['admin', 'billing', 'editing', 'sales', 'talent_coordinator'];

export function AdminProtectedRoute({ children }: ProtectedRouteProps) {
  const { isAuthenticated, isLoading, user } = useAdminAuth();

  // While checking session, show loader
  if (isLoading) {
    return (
      <div className="min-h-screen flex items-center justify-center">
        <div className="text-center">
          <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-primary mx-auto"></div>
          <p className="mt-4 text-muted-foreground">Loading...</p>
        </div>
      </div>
    );
  }

  // Reject if not authenticated or user has no valid staff role
  if (!isAuthenticated || !user || !VALID_STAFF_ROLES.includes(user.role)) {
    return <Navigate to="/lp-console" replace />;
  }

  return <>{children}</>;
}
